import { combineTextDescendants } from './utilities.mjs';

/**
 * Deserialize HTML body element to Fragment.
 */
function deserializeHTMLToFragment({
  element,
  children
}) {
  if (element.nodeName === 'BODY') {
    return combineTextDescendants(children);
  }
  return undefined;
}

export { deserializeHTMLToFragment };
